// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"613":"4cd1ae73","640":"4cd1ae73","642":"4cd1ae73","818":"4cd1ae73","951":"4cd1ae73"}[chunkId] + ".chunk.css";
};